import { Injectable, InjectionToken } from '@angular/core';
import { combineLatest, distinctUntilChanged, map, Observable, Subject } from 'rxjs';

export interface NoticesScrolling {
  reachedBottomOfContent$: Observable<boolean>;
  setLowerThreshold: (element: Element) => void;
  upperElementScrolled: (element: Element) => void;
}

export const SCROLL_SERVICE = new InjectionToken<NoticesScrolling>('SCROLL_SERVICE');

/*
 *
 *  This service isn't meant for general use. Don't do it.
 *
 */
@Injectable()
export class ScrollService implements NoticesScrolling {
  private lowerElement$ = new Subject<Element>();
  private upperElement$ = new Subject<Element>();

  public reachedBottomOfContent$ = combineLatest([this.lowerElement$, this.upperElement$]).pipe(
    map(([lower, upper]) => {
      const bottomOfTheUpperElement = upper.getBoundingClientRect().bottom;
      const topOfTheLowerElement = lower.getBoundingClientRect().top;

      return bottomOfTheUpperElement <= topOfTheLowerElement;
    }),
    distinctUntilChanged()
  );

  public setLowerThreshold = (lowerElement: Element) => {
    this.lowerElement$.next(lowerElement);
  };

  public upperElementScrolled = (upperElement: Element) => {
    this.upperElement$.next(upperElement);
  };
}
